<template>
<details>
	<summary>Object</summary>
	<div>{{content}}</div>
</details>
</template>

<script>

export default {
	name: "JmObject",

	props: {
		content: Object
	}
};
</script>

<style lang="stylus" scoped>
details > div
	font-family courier, monospace
	font-size 80%
</style>



// WEBPACK FOOTER //
// src/components/widgets/ItemViewWidgets/Object.vue